export default "__VITE_ASSET__356a7748__"